// extracted by mini-css-extract-plugin
module.exports = {"divider":"SelectSerialNumber_divider__2FLJV"};